module.exports = __webpack_public_path__ + "static/media/x_icon_dark.47b01084.svg";